import React, { useEffect, useMemo, useState } from "react";
import { FaUser } from "react-icons/fa";
import { clientMasterServicer } from "../../Commen_Services/clientmaster.service";
import { Box, FormControl, IconButton, TablePagination, TextField, useTheme } from "@mui/material";
import { Edit, KeyboardArrowLeft, KeyboardArrowRight } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import Popup from "reactjs-popup";
import AddClient from "./AddClient";
import LastPageIcon from '@mui/icons-material/LastPage';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import DeleteIcon from '@mui/icons-material/Delete';
import customToast from "../Toast/CustomToast";

interface ColumnData {
    Column_name: string;
    Header_name: string;
    Is_Display: boolean;
    Is_Export: boolean;
    Is_active: boolean;
}

interface TablePaginationActionsProps {
    count: number;
    page: number;
    rowsPerPage: number;
    onPageChange: (
        event: React.MouseEvent<HTMLButtonElement>,
        newPage: number,
    ) => void;
}

interface RowData {
    [key: string]: any;
}

const ClientMaster: React.FC = () => {

    const [columnData, setColumnData] = useState<ColumnData[]>([]);
    const [tableData, setTableData] = useState<RowData[]>([]);
    const [addClientPopup, setAddclientPopup] = useState(false);
    const [refreshData, setRefreshData] = React.useState(false);
    const [rowsPerPageForTable, setRowsPerPageForTable] = React.useState<number>(10);
    const [page, setPage] = React.useState<number>(0);
    const [searchTerm, setSearchTerm] = useState('');
    const [sortConfig, setSortConfig] = useState<{ key: string, direction: 'asc' | 'desc' } | null>(null);
    const displayColumns = columnData.filter(col => col.Is_Display);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchTableData = async () => {
            const { data: tabledatafromAPI } = await clientMasterServicer.getclientproductlist();
            console.log(tabledatafromAPI);
            setColumnData(tabledatafromAPI?.columnDetails);
            setTableData(tabledatafromAPI?.tableData);
        }
        fetchTableData();
        console.log(refreshData,'called')
    }, [refreshData])

    const sortedData = useMemo(() => {
        let filteredData = tableData.filter(row =>
            displayColumns.some(col =>
                String(row[col.Column_name] ?? '')
                    .toLowerCase()
                    .includes(searchTerm.toLowerCase())
            )
        );

        if (sortConfig !== null) {
            filteredData = [...filteredData].sort((a, b) => {
                const aVal = a[sortConfig.key];
                const bVal = b[sortConfig.key];
                if (aVal === bVal) return 0;
                return (aVal > bVal ? 1 : -1) * (sortConfig.direction === 'asc' ? 1 : -1);
            });
        }
        const currentTableRows = filteredData.slice(page * rowsPerPageForTable, page * rowsPerPageForTable + rowsPerPageForTable);
        return currentTableRows;
    }, [searchTerm, sortConfig, tableData, page, rowsPerPageForTable]);

    const handleSort = (key: string) => {
        setSortConfig(prev => {
            if (prev?.key === key) {
                return { key, direction: prev.direction === 'asc' ? 'desc' : 'asc' };
            }
            return { key, direction: 'asc' };
        });
    };

    const handleEditNewButtonData = (data: any) => {
        let url = '/ClientMaster/productlist/' + data;
        let keyName = null;
        navigate(url);
    }

    const handleChangePage = (event: unknown, newPage: number) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRowsPerPageForTable(parseInt(event.target.value, 10));
        setPage(0);
    };


    function TablePaginationActions(props: TablePaginationActionsProps) {
        const theme = useTheme();
        const { count, page, rowsPerPage, onPageChange } = props;

        const handleFirstPageButtonClick = (
            event: React.MouseEvent<HTMLButtonElement>,
        ) => {
            onPageChange(event, 0);
        };

        const handleBackButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
            onPageChange(event, page - 1);
        };

        const handleNextButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
            onPageChange(event, page + 1);
        };

        const handleLastPageButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
            onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
        };

        return (
            <Box sx={{ flexShrink: 0, ml: 2.5 }}>
                <IconButton
                    onClick={handleFirstPageButtonClick}
                    disabled={page === 0}
                    aria-label="first page"
                >
                    {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
                </IconButton>
                <IconButton
                    onClick={handleBackButtonClick}
                    disabled={page === 0}
                    aria-label="previous page"
                >
                    {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
                </IconButton>
                <IconButton
                    onClick={handleNextButtonClick}
                    disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                    aria-label="next page"
                >
                    {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
                </IconButton>
                <IconButton
                    onClick={handleLastPageButtonClick}
                    disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                    aria-label="last page"
                >
                    {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
                </IconButton>
            </Box>
        );
    }

    return (<>
        <div>
            <div className="shadow">
                <div className="bg-line">
                    <span className="bg-head"><FaUser /> &nbsp;Client Master</span>
                </div>
                <hr className="colorgraph" />
            </div>
        </div>
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', padding: '0px 15px' }}>

            <FormControl variant="standard">
                <TextField
                    variant="standard"
                    label="search"
                    onChange={e => setSearchTerm(e.target.value)}
                    value={searchTerm}
                    InputLabelProps={{
                        style: {
                            color: 'var(--body-main-dark-color)',
                            fontSize: '12px',
                            borderColor: 'red',
                        },
                    }}
                    InputProps={{
                        style: {
                            width: '250px',
                        }
                    }}
                />
            </FormControl>
            <div>
                <button className={`btn123 `} onClick={() => {
                    setAddclientPopup(true);
                }}
                    style={{ padding: 14, backgroundColor: 'var(--body-main-dark-color)', color: '#fff' }}>Add New</button>
            </div>
        </div>

        <div className="p-4 font-sans">
            <div
                className="table-wrapper"
                style={{
                    width: "100%",
                    //maxHeight: "300px",
                    overflowY: "auto",
                    border: "1px solid #ddd",
                }}
            >
                {/* Table Header */}
                <table style={{ width: "100%", tableLayout: "fixed", borderCollapse: "collapse" }}>
                    <colgroup>
                        {displayColumns.map((col, index) => (
                            <col key={index} style={{ width: `${100 / (displayColumns.length + 1)}%` }} />
                        ))}
                        <col style={{ width: "100px" }} />
                    </colgroup>
                    <thead>
                        <tr
                            style={{
                                backgroundColor: "var(--body-main-light-color)",
                                fontSize: "13px",
                                fontWeight: "bold",
                                color: "var(--body-main-dark-color)",
                            }}
                        >
                            {displayColumns.map((col) => (
                                <td
                                    key={col.Column_name}
                                    className="border px-4 py-2 cursor-pointer bg-gray-100"
                                    style={{
                                        padding: "5px",
                                        position: "sticky",
                                        top: 0,
                                        zIndex: 2,
                                        background: "var(--body-main-light-color)",
                                    }}
                                    onClick={() => handleSort(col.Column_name)}
                                >
                                    {col.Header_name || col.Column_name}
                                    {sortConfig?.key === col.Column_name &&
                                        (sortConfig.direction === "asc" ? " 🔼" : " 🔽")}
                                </td>
                            ))}
                            <td
                                style={{
                                    position: "sticky",
                                    top: 0,
                                    zIndex: 2,
                                    background: "var(--body-main-light-color)",
                                }}
                            ></td>
                        </tr>
                    </thead>
                </table>

                {/* Scrollable Body */}
                <div style={{ height: "calc(100vh - 320px)", overflowY: "auto" }}>
                    <table style={{ width: "100%", tableLayout: "fixed", borderCollapse: "collapse" }}>
                        <colgroup>
                            {displayColumns.map((col, index) => (
                                <col key={index} style={{ width: `${100 / (displayColumns.length + 1)}%` }} />
                            ))}
                            <col style={{ width: "100px" }} />
                        </colgroup>
                        <tbody style={{ background: "var(--button-color-light)" }}>
                            {sortedData.map((row, idx) => (
                                <tr key={idx} className="odd:bg-white even:bg-gray-50">
                                    {displayColumns.map((col) => (
                                        <td
                                            key={col.Column_name}
                                            className="border px-4 py-2"
                                            style={{ padding: "5px", fontSize: "13px", wordBreak: "break-word" }}
                                        >
                                            {row[col.Column_name]}
                                        </td>
                                    ))}
                                    <td>
                                        <IconButton aria-label="select" sx={{ color: 'var(--body-main-dark-color)' }} onClick={(event) => { event.stopPropagation(); handleEditNewButtonData(row['CL_ID']); }}><Edit /></IconButton>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* Pagination Footer */}
            <div>
                <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={tableData ? tableData.length : 0}
                    rowsPerPage={rowsPerPageForTable}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    ActionsComponent={TablePaginationActions}
                />
            </div>
        </div>


        {addClientPopup && (
            <Popup contentStyle={{ width: '80%', padding: 0 }} position='top center' open={addClientPopup} onClose={() => setAddclientPopup(false)} closeOnDocumentClick={false}>
                <AddClient openClose={() => setAddclientPopup(false)} refreshGrid={() => { refreshData ? setRefreshData(false) : setRefreshData(true) }} />
            </Popup>
        )}
    </>);
}

export default ClientMaster;